<script>
import { Line, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  plugins: [ChartDataLabels],
  props: ['options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options)
  }
}
</script>
